import doc                      from '@widesk-core/decorators/doc';
import AbstractStandStatusModel from './AbstractStandStatusModel';
import model                    from '@widesk-core/decorators/model';

@doc.urnResource('stand_status')
@model.cacheDuration()
export default class StandStatusModel extends AbstractStandStatusModel {
	get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
